export const msalConfig = {
  auth: {
    clientId: "0e9d121b-3bf7-4da4-ad52-d6680a53c507",
    authority:
      "https://login.microsoftonline.com/8c4858b5-f020-483a-b7ef-71ded6e81767",
    redirectUri: window.location.origin,
    // redirectUri: "http://localhost:3000",
    // redirectUri: "https://mldldigisales-uat.m-devsecops.com",
    
  },
  // cache: {
  //   cacheLocation: "sessionStorage", // or "localStorage"
  // },
};

export const loginRequest = {
  scopes: [
    "User.Read",
    "OnlineMeetings.ReadWrite",
    "api://0e9d121b-3bf7-4da4-ad52-d6680a53c507/access_as_user",
  ],
};
